export function getRedirectTo(location) {
    const urlParams = new URLSearchParams(location.search);
    const redirectTo = location.state?.redirectTO || urlParams.get('redirectTo');

    if (!redirectTo || !redirectTo.startsWith('/') || redirectTo.startsWith('//')) {
        return null;
    }

    return redirectTo;
}
